import CornermarkAddPage from "@saleor/cornermarks/components/CornermarkAddPage";
import { CornermarkPageFormData } from "@saleor/cornermarks/components/CornermarkPage";
import { useCornermarkCreateMutation } from "@saleor/cornermarks/mutations";
import {
  CornermarkAddUrlQueryParams,
  cornermarkListUrl,
  cornermarkUrl
} from "@saleor/cornermarks/urls";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import React from "react";
import { useIntl } from "react-intl";

interface CornermarkDetailsProps {
  params: CornermarkAddUrlQueryParams;
}

const CornermarkDetails: React.FC<CornermarkDetailsProps> = ({}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const [cornermarkCreate, cornermarkCreateOpts] = useCornermarkCreateMutation({
    onCompleted: data => {
      if (data.cornerMarkCreate.errors.length === 0) {
        notify({
          status: "success",
          text: intl.formatMessage({
            defaultMessage: "Successfully created cornermark"
          })
        });
        navigate(cornermarkUrl(data.cornerMarkCreate.cornerMark.id));
      }
    }
  });

  const handleSubmit = async (data: CornermarkPageFormData) => {
    const input = {
      ...data
    };
    const result = await cornermarkCreate({
      variables: {
        input
      }
    });
    return result.data.cornerMarkCreate?.cornerMark?.id || null;
  };
  return (
    <>
      <CornermarkAddPage
        cornermark={null}
        disabled={cornermarkCreateOpts.loading}
        errors={cornermarkCreateOpts.data?.cornerMarkCreate.errors || []}
        onBack={() => navigate(cornermarkListUrl())}
        onDelete={undefined}
        onSubmit={handleSubmit}
        saveButtonBarState={cornermarkCreateOpts.status}
        title={"add"}
      />
    </>
  );
};

export default CornermarkDetails;
